import Field from '../Field'
import toInteger from 'lodash/toInteger'

export default class extends Field {
  static name = 'integer'

  mutator (value) {
    return toInteger(value)
  }
}
